import { Box, Icon, Skeleton } from "@prismicio/editor-ui"

import type { Release } from "../../app/services/release"

interface ReleaseStatusIndicatorProps {
  release: Release | undefined
}

export function ReleaseStatusIndicator(props: ReleaseStatusIndicatorProps) {
  const { release } = props

  if (!release) return <Skeleton height={24} width={24} />

  return (
    <Box
      padding={4}
      backgroundColor={release.timestamp ? "green3" : "tomato3"}
      borderRadius={6}
    >
      <Icon
        name="calendarToday"
        color={release.timestamp ? "green11" : "tomato11"}
        size="small"
      />
    </Box>
  )
}
